/*
---------------------------------
Module - popup-notification
---------------------------------
*/

import { Modal } from "../../modal/js/global";
import { setCookie } from "PlugAndPlay/_global/js/cookieHelper";

export default function _popupNotification() {

    /**
     * Content popup notification wrapper selector
     * @const {string}
     */
    const POPUP_NOTIFICATION_WRAPPER_SELECTOR = '[data-component="popup-notification"]';

    /**
     * Content modal header selector
     * @const {string}
     */
    const POPUP_NOTIFICATION_HEADER_SELECTOR = '[data-component="content-modal-header"]';

    /**
     * Content modal footer selector
     * @const {string}
     */
     const POPUP_NOTIFICATION_FOOTER_SELECTOR = '[data-component="content-modal-footer"]';
    

    class PopupNotification extends Modal {

        constructor(modalWrapper) {

            super(modalWrapper);

            /*
                The modal body has a scroll on it, but not the header so
                calculate the offset for the body height so it scrolls properly
            */
            const modalHeader = modalWrapper.querySelector(POPUP_NOTIFICATION_HEADER_SELECTOR);

            if (modalHeader) {

                modalWrapper.style.setProperty("--content-modal-header-height",`${modalHeader.scrollHeight}px`);

            }

            const modalFooter = modalWrapper.querySelector(POPUP_NOTIFICATION_FOOTER_SELECTOR);

            if (modalFooter) {

                modalWrapper.style.setProperty("--content-modal-footer-height", `${modalFooter.scrollHeight}px`);

            }

            this.openModal();

        }

        openModal() {

            super.openModal();

            if (this.modal) {
                this.modalWrapper.style.setProperty("--content-modal-content-height", `${this.modal.clientHeight}px`);
            }

            // create an Observer instance
            const contentModal = this;

            this.resizeObserver = new window.ResizeObserver(() => {
                contentModal.modalWrapper.style.setProperty("--content-modal-content-height", `${contentModal.modal.clientHeight}px`);
            });

            // start observing a DOM node
            this.resizeObserver.observe(this.modal);
        }

        /**
         * Remove watcher on modal close
         */
        closeModal() {
            super.closeModal();
            this.resizeObserver.unobserve(this.modal);

            // Set cookie based on data attribute
            const timeStamp = this.modalWrapper.getAttribute("data-timestamp");

            if (timeStamp) {
                
                // Set a cookie so that pop up won't show for 30 days
                setCookie("popup-notification-dismissed", timeStamp, 30);

                // Reset focus to logo link
                document.querySelector(".primary-nav__logo").focus();

            }

        }

    }

    // Find popup notification
    const popupNotification = document.querySelector(POPUP_NOTIFICATION_WRAPPER_SELECTOR);
    
    if (popupNotification) {
        popupNotification.modal = new PopupNotification(popupNotification);
    }
    
}

_popupNotification();


